import React, { useEffect, useState } from 'react';
import TalkServiceContainer from './chatting/TalkServiceContainer';
import TranslateContainer from './translate/TranslateContainer';

export default function SideWrapper(props) {
  return (
    <div className={props.popup ? '' : `live_player_side_w ${(props.mode ? props.mode + '_current' : '')}`}>
      {props.mode === 'translate' && (<TranslateContainer view={props.mode === 'translate'} popup={props.popup} data={props.data} onError={props.onError} onBackFocus={props.onBackFocus} />)}
      {props.mode === 'livechat' && (<TalkServiceContainer view={props.mode === 'livechat'} channel={props.channel} />)}
    </div>
  );
}
